module.exports = __webpack_public_path__ + "static/media/1.adbe7a5a.png";